import { GeneralStyle } from '@website-builder/model/style/general-style';

export class PopoverStyle extends GeneralStyle {
  static normalize(styles: Partial<PopoverStyle>): PopoverStyle {
    const generalStyle = GeneralStyle.normalize(styles);
    const accordionStyle = new PopoverStyle();

    Object.assign(accordionStyle, generalStyle);

    return accordionStyle;
  }
}
